export default __webpack_public_path__ + "media/components/blocks/ExploreAndDiscover/arrow_up-d94765395aef0d8d08cd4f524626d82a.png";